/**
 * This file exists to alleviate the suffering caused by the magic Google Maps globals.
 *
 * During development the Google Maps script is included via ~/public/index.html.
 */
let GOOGLE_MAPS: any;
let timeout = 100;

timeout *= 2;

const checkGoogleMaps = () => {
  if ((window as any).google?.maps) {
    GOOGLE_MAPS = (window as any).google.maps;
    console.log('Google Maps is available!');
  } else {
    setTimeout(checkGoogleMaps, timeout);
    timeout *= 2;
  }
};

checkGoogleMaps();

export enum PlacesServiceResponseCode {
  OK = 'OK',
  // More of type is not used.
}

export type PlacesServiceResponse = Array<{
  place_id: string;
  description: string;
  // More of type is not used.
}>;

let GOOGLE_MAPS_AUTOCOMPLETE: any;
export function getAutocompleteService() {
  if (!GOOGLE_MAPS) {
    throw new Error('Google Maps global is not available');
  }
  if (!GOOGLE_MAPS_AUTOCOMPLETE) {
    GOOGLE_MAPS_AUTOCOMPLETE = new GOOGLE_MAPS.places.AutocompleteService();
  }
  return GOOGLE_MAPS_AUTOCOMPLETE;
}

export enum GeocodeServiceResponseCode {
  OK = 'OK',
  // More of type is not used.
}

export type GeocodeServiceResponse = [
  {
    geometry: {
      location: {
        lat(): number;
        lng(): number;
      };
    };
  }
  // More of type is not used.
];

let GOOGLE_MAPS_GEOCODE: any;
export function getGeocodeService() {
  if (!GOOGLE_MAPS) {
    throw new Error('Google Maps global is not available');
  }
  if (!GOOGLE_MAPS_GEOCODE) {
    GOOGLE_MAPS_GEOCODE = new GOOGLE_MAPS.Geocoder();
  }
  return GOOGLE_MAPS_GEOCODE;
}
